
import { environment } from 'src/environments/environment';
import { AppSettings } from '../../app/appSettings';
import moment from 'moment';

export class SearchResult {
  doctor: Doctor | null;
  practice: Practice | null;
  distance: number;
  close: boolean;
  active = false;
  favid: number;
  zip: string | null;
  externalDoc: any;
  hasAppointments?: boolean;
  hasVSS?: boolean;
  hasRequests?: boolean;
  specName?: string;
  praxis?: string;
  hasExternalAppointments?: boolean;

  constructor(obj?: any) {
    this.distance = obj && parseFloat(obj.distance) || 0;
    this.doctor = obj && new Doctor(obj) || null;
    this.practice = obj && new Practice(obj) || null;
    this.externalDoc = obj && obj.externalDoc || null;
    this.favid = 0;
    if (this.distance < 1) {
      this.close = true;
    } else {
      this.close = false;
    }
  }
}
export class ZipResults{
city: string[];
district: string[];
zip: string[];

constructor(obj?: any){
  this.city = obj && obj.city || null;
  this.district = obj && obj.district || null;
  this.zip = obj && obj.zip || null;

}
}


export class Doctor {
  id: number;
  extId: string;
  anr: string;
  title: string;
  name: string;
  surname: string;
  tel: string;
  mob:string;
  email: string;
  subemail: string;
  practice: number;
  image: string = "assets/images/medical-icon-grey.png";
  newPic:any;
  firma: string;
  praxis: string;
  specs: Array<any>;
  topspec:Array<any>;
  specialisations: Array<number>;
  address: string;
  city: string;
  zip: string;
  web: string;
  lang: string;
  contactable: boolean;
  request_recipe: boolean;
  request_transfer: boolean;
  request_appointment: boolean;
  request_general: boolean;
  request_custom: boolean;
  request_customText: string;
  treatment_reason_mode: boolean;
  treatment_reason_question: string;
  treatment_reason_action: string;
  recipe_request_mode: boolean;
  widget_request_button: boolean;
  emails: number;
  name_nice: string;
  city_nice: string;
  specs_nice: string;
  name_plus_specs: string;
  nextEvent: string;
  treatment_reasons: Array<any>;
  appsInQuarter: number;
  favContact: number;
  remindPatientMessage: number;
  internalBooking: boolean;
  rememberSms: number;
  premium_plan: number;
  waitinglist: number;
  autoRestoreStorno: number;
  stornoTime: string;
  blacklistText: string;
  extData: any;
  externalDoc = 0;
  isAppointmentBookingDeactivated: boolean;
	package: number;

  constructor(obj?: any, asProfile : Boolean=false,
  ) {
    this.id = obj && (obj?.id?.length == 32 ? obj?.id : parseInt(obj?.id)) || null;
    this.anr = obj && ((obj.anr == "0") ? "Herr" : ((obj.anr == "1") ? "Frau" : ((obj.anr == "2" ? "-" : "")))) || "";
    this.title = obj && obj.title || "";
    this.name = obj && obj.name || "";
    this.surname = obj && obj.surname || "Arzt nicht verfügbar";
    this.tel = obj && obj.tel || "";
    this.mob = obj && obj.mob || "";
    this.email = (obj && (obj.contactable || asProfile) && obj.email) ? obj.email : null;
    this.subemail = obj && obj.subemail || "";
    this.favContact = obj && obj.favContact || "0";
    this.remindPatientMessage = obj && obj.remindPatientMessage || "0";
    this.premium_plan = obj && obj.premium_plan || "0";

    this.practice = obj && parseInt(obj.practice) || null;
    if (this.practice == 0 || this.practice === null) {
      this.practice = this.id;
    }

    this.firma = obj && obj.firma || "";
    this.praxis = obj && obj.praxis || "";
    this.specs = obj && obj.specs || [];
    this.address = obj && obj.address || "";
    this.city = obj && obj.city || "";
    this.zip = obj && obj.zip || "";
    this.web = obj && obj.web || "";
    this.lang = obj && obj.lang || "";
    this.contactable = obj && (obj.contactable == "1") ? true : false || null;
    this.request_recipe = obj && (obj.request_recipe == "1") ? true : false || null;
    this.request_transfer = obj && (obj.request_transfer == "1") ? true : false || null;
    this.request_appointment = obj && (obj.request_appointment == "1") ? true : false || null;
    this.request_general = obj && (obj.request_general == "1") ? true : false || null;
    this.request_custom = obj && (obj.request_custom == "1") ? true : false || null;
    this.request_customText = obj && this.request_customText || "";
    this.nextEvent = obj && obj.nextEvent || null;
    this.name_nice = [this.title, this.name, this.surname].filter(function (val) { return val; }).join(' ');
    this.city_nice = [this.zip, this.city].filter(function (val) { return val; }).join(' ');
    this.treatment_reason_mode = obj && (obj.treatment_reason_mode == "1") ? true : false;
    this.internalBooking = obj && (obj.internalBooking == "1") ? true : false || null;
    this.rememberSms = obj && (obj.rememberSms == "1") ? 1 : 0 || 0;
    this.waitinglist = obj && (obj.waitinglist == "1") ? 1 : 0 || 0;
    this.autoRestoreStorno = obj && (obj.autoRestoreStorno == "1") ? 1 : 0 || 0;
    this.stornoTime = obj && obj.stornoTime && obj.stornoTime !== "0" ? obj.stornoTime : "";
    this.recipe_request_mode = obj && (obj.recipe_request_mode == "1") ? true : false || null;
    this.widget_request_button = obj && (obj.widget_request_button == "1") ? true : false || null;

    this.appsInQuarter = obj && obj.appsInQuarter || null;
    this.emails = obj && parseInt(obj.emails) || 0;
    this.treatment_reason_action = obj && obj.treatment_reason_action || null;
    this.treatment_reason_question = obj && obj.treatment_reason_question || null;
    this.treatment_reasons = obj && obj.treatment_reasons || [];
    //this.rights_table_id = obj && obj.rights_table_id || null;
    //this.isPin = obj && obj.isPin || 0;

    //Todo hier muss rights_table_id rein
    this.blacklistText = obj && obj.blacklistText || "";
    let specs = [];
    for (let spec of this.specs) {
      specs.push(spec.name);
    }
    this.specs_nice = specs.join(', ');

    this.name_plus_specs = this.name_nice;
    if (this.specs_nice !== "") {
      this.name_plus_specs += ' (' + this.specs_nice + ')';
    }

    if (obj && obj.image) {
      if (obj.image.indexOf(this.image) === -1) {
        if (obj.image.indexOf(environment.baseUrl) === -1) {
          this.image = environment.baseUrl + "res/images/" + this.practice + "/" + obj.image;
        } else {
          this.image = obj.image;
        }
      }
    }
    this.extData = obj && obj.extData || false;
    this.isAppointmentBookingDeactivated = !!(obj && obj.isAppointmentBookingDeactivated === '1' ? true : false );
		this.package = (obj && +obj.package) || 0;
	}

	public isCalendarActive(): boolean {
		return !this.isAppointmentBookingDeactivated && this.package >= 0;
	}
}

export class DoctorExternal {
  id: string;
  anr: string;
  title: string;
  name: string;
  surname: string;
  tel: string;
  email: string;
  praxis: string;
  specs: string;
  address: string;
  city: string;
  zip: string;
  web: string;
  name_nice: string;
  city_nice: string;
  specs_nice: string;
  name_plus_specs: string;
  contactable: boolean;
  office_hours: string;
  speciality: string;
  extData:any;
  image: string = "assets/images/medical-icon-grey.png";
  externalDoc = 1;

  constructor(obj?: any
  ) {
    this.id = obj && obj.id || null;
    this.anr = obj && ((obj.anr == "0") ? "Herr" : ((obj.anr == "1") ? "Frau" : ((obj.anr == "2" ? "-" : "")))) || "";
    this.title = obj && obj.title || "";
    this.name = obj && obj.name || "";
    this.surname = obj && obj.surname || "Arzt nicht verfügbar";
    this.tel = obj && obj.tel || "";
    this.email = obj && obj.email || "";

    this.praxis = obj && obj.practice || "";
    this.specs = obj && obj.specs || "";
    this.address = obj && obj.address || "";
    this.city = obj && obj.city || "";
    this.zip = obj && obj.zip || "";
    this.web = obj && obj.url || "";
    this.contactable = false || null;
    this.name_nice = [this.title, this.name, this.surname].filter(function (val) { return val; }).join(' ');
    this.city_nice = [this.zip, this.city].filter(function (val) { return val; }).join(' ');
    this.speciality = obj.fach || "";
    this.specs_nice = obj.fach_category || "";
    this.name_plus_specs = this.name_nice;
    if (this.specs_nice !== "") {
      this.name_plus_specs += ' (' + this.specs_nice + ')';
    }
    this.extData = false;
    this.office_hours = obj && obj.office_hours || [];
  }
}

export class DoctorDetail {
  id: string;
  title: string;
  name: string;
  surname: string;
  name_nice: string;
  address: Address;
  praxis: string;
  distance: string;
  specs: Array<Spec>;
  specs_nice: string;
  web: string;
  tel: string;
  generalInfo: string;
  externLink: string;

  externButton: boolean;
  showServices: boolean;
  hasAppointments: boolean;
  hasRequests: boolean;
  additionalDocs: boolean;
  additionalDocList: Array<AdditionalDoctor>;
  docServices: Array<Service>;
  requestTypes: Array<RequestType>;
  officeHours: Array<OfficeHours>;
  images: Array<string>;
  hasVSS: boolean;
  onlyEvents: boolean;
  appReasons: boolean;
  plugin: boolean;
  questiontree: boolean;
  showOfficeHours:boolean;

  appReasonConfig;
  pluginConfig;
  questionTreeConfig;
  waitinglist:boolean;

  constructor(obj?: any
  ) {
    this.id = obj && obj.id || "";
    this.title = obj && obj.title || "";
    this.name = obj && obj.name || "";
    this.surname = obj && obj.surname || "";
    this.name_nice = [this.title,this.name,this.surname].join(" ");
    this.address = obj && obj.address || new Address();
    this.praxis = obj && obj.praxis || "";
    this.distance = obj && obj.distance || "";
    this.specs = obj && obj.specs || [];
    if(this.specs.length > 0){
      let specs = [];
      this.specs.forEach(spec => {
          specs.push(spec.name);
      });
      this.specs_nice = specs.join(" / ");
    }
    
    this.web = obj && obj.web || "";
    this.tel = obj && obj.tel || "";
    this.generalInfo = obj && obj.generalInfo || "";
    this.externLink = obj && obj.externLink || "";
    this.externButton = obj && obj.externButton || false;
    this.showServices = obj && obj.showServices || false;
    this.hasAppointments = obj && obj.hasAppointments || false;
    this.hasRequests = obj && obj.hasRequests || false;
    this.additionalDocs = obj && obj.additionalDocs || false;
    this.additionalDocList = [];
    if(obj && obj.additionalDocList){
      obj.additionalDocList.forEach(element => {
        this.additionalDocList.push(new AdditionalDoctor(element));
      });
    }
    this.docServices = [];
    if(obj && obj.docServices){
      obj.docServices.forEach(element => {
        this.docServices.push(new Service(element));
      });
    }
    this.requestTypes = [];
    if(obj && obj.requestTypes){
      obj.requestTypes.forEach(element => {
        this.requestTypes.push(new RequestType(element));
      });
    }
    let officeHours = obj && obj.officeHours || [[new OfficeHours()],[new OfficeHours()],[new OfficeHours()],[new OfficeHours()],[new OfficeHours()],[new OfficeHours()],[new OfficeHours()]];
    let openingHours = [];
    for (let index = 0; index < officeHours.length; index++) {
      let day = "";
      switch (index) {
        case 0:
          day = "Montag";
          break;
        case 1:
          day = "Dienstag";
          break;
        case 2:
          day = "Mittwoch";
          break;
        case 3:
          day = "Donnerstag";
          break;
        case 4:
          day = "Freitag";
          break;
        case 5:
          day = "Samstag";
          break;
        case 6:
          day = "Sonntag";
          break;
        default:
          break;
      }
      let hours = officeHours[index].join(", ");
      if(hours == ""){
        hours = "-";
      }else{
        this.showOfficeHours = true;
      }
      openingHours.push(new OfficeHours({"day":day,"hours":hours}));
    }
    this.officeHours = openingHours;
    
    this.images = obj && obj.images || [];
    this.hasVSS = obj && obj.hasVSS || false;
    this.onlyEvents = obj && obj.onlyEvents || false;
    this.appReasons = obj && obj.appReasons || false;
    this.plugin = obj && obj.plugin || false;
    this.questiontree = obj && obj.questiontree || false;

    this.appReasonConfig = obj && obj.appReasonsConfig || [];
    this.pluginConfig = obj && obj.pluginConfig || [];
    this.questionTreeConfig = obj && obj.questionTreeConfig || [];
    this.waitinglist = obj && obj.waitinglist || false;

    if(this.id == ""){
      this.name_nice = "Arzt nicht verfügbar";
      this.hasAppointments = false;
      this.hasRequests = false;
      this.externButton = false;
    }
  }
}

export class OfficeHours{
  day: string;
  hours: string;

  constructor(obj?: any
  ) {
    this.day = obj && obj.day || "";
    this.hours = obj && obj.hours || "";
  }
}

export class Address{
  street: string;
  zip: string;
  city: string;
  lat;
  long;

  constructor(obj?: any
  ) {
    this.street = obj && obj.street || "";
    this.zip = obj && obj.zip || "";
    this.city = obj && obj.city || "";
    this.lat = obj && obj.lat || 0;
    this.long = obj && obj.long || 0;
  }
}

export class AdditionalDoctor{
  id: string;
  title: string;
  name: string;
  surname: string;
  name_nice: string;
  address: string;
  zip: string;
  city: string;

  constructor(obj?: any
  ) {
    this.id = obj && obj.id || "";
    this.title = obj && obj.title || "";
    this.name = obj && obj.name || "";
    this.surname = obj && obj.surname || "";
    this.name_nice = [this.title,this.name,this.surname].join(" ");
    this.address = obj && obj.address || "";
    this.zip = obj && obj.zip || "";
    this.city = obj && obj.city || "";
  }
}

export class Service{
  title: string;
  description: string;

  constructor(obj?: any
  ) {
    this.title = obj && obj.title || "";
    this.description = obj && obj.description || "";
  }
}
export class RequestType{
  name: string;
  text: string;
  type: number;
  active: boolean;

  constructor(obj?: any
  ) {
    this.name = obj && obj.name || "";
    this.text = obj && obj.text || "";
    this.type = obj && obj.type || 0;
    this.active = obj && obj.active || false;
  }
}

export class PatientEvent{
  id: string;
  startDate: Date;
  status: number;
  booked: Date;
  reason: string;
  thirds: boolean;
  thirds_name: string;
  thirds_lastname: string;

  constructor(obj?: any
  ) {
    this.id = obj && obj.id || null;
    this.startDate = obj && moment(obj.start).toDate() || null;
    this.status = obj && obj.status || 0;
    this.booked = obj && new Date(+obj.booked * 1000) || null;
    this.reason = obj && obj.reason || "";
    this.thirds = false;
    if(obj && obj.thirds){
      switch(+obj.thirds){
        case 0:break;
        case 1:
        case 2:
        case 3:
          this.thirds = true;
          break;
        default:break;
      }
    }
    this.thirds_name = obj && obj.thirds_name || "";
    this.thirds_lastname = obj && obj.thirds_lastname || "";
  }
}

export class PraxisImagesClass {
  name: string;
  isPracticeImage: string;
  doctor: string;
  id: string;
  rawFile: string;

  constructor(obj?: any) {
    this.id = obj && obj.id || "";
    this.doctor = obj && obj.doctor || "";
    this.name = obj && obj.name || "";
    this.isPracticeImage = obj && obj.isPracticeImage || "";
  }

}



export class Practice {
  id: number;
  web: string;
  tel: string;
  firma: string;
  praxis: string;
  specs: any;
  docs: Array<any>;
  info: string;
  image: string = "assets/images/no-doc.jpg";
  images: Array<PraxisImagesClass>;
  ausbildung: string;
  philo: string;
  leistung: string;
  lang: string;
  address: string;
  zip: string;
  city: string;
  city_nice: string;
  specs_nice: string;

  constructor(obj?: any) {
    this.id = obj && parseInt(obj.id) || null;
    this.tel = obj && obj.tel || "";
    this.firma = obj && obj.firma || "";
    this.praxis = obj && obj.praxis || "";
    this.specs = obj && obj.specs || [];
    this.docs = obj && obj.docs || [];
    this.ausbildung = obj && obj.ausbildung || "";
    this.philo = obj && obj.philo || "";
    this.leistung = obj && obj.leistung || "";
    this.info = obj && obj.praxis_info || "";
    this.address = obj && obj.address || "";
    this.city = obj && obj.city || "";
    this.zip = obj && obj.zip || "";
    this.web = obj && obj.web || "";
    this.lang = obj && obj.lang || "";
    this.city_nice = [this.zip, this.city].filter(function (val) { return val; }).join(' ');
    if (obj && obj.image) {
      if (obj.image.indexOf("assets/images/no-doc.jpg") === -1) {
        if (obj.image.indexOf(environment.baseUrl) === -1) {
          this.image = environment.baseUrl + "/res/images/" + this.id + "/" + obj.image;
        } else {
          this.image = obj.image;
        }
      }
    }
    this.images = obj && obj.images || [];

  }

}

export class Networker {
  id: number;
  email: string;
  name: string;
  surname: string;
  number_apps: number;

  constructor(obj?: any) {
    this.id = obj && parseInt(obj.id) || null;
    this.email = obj && obj.email || "";
    this.name = obj && obj.name || "";
    this.surname = obj && obj.surname || "";
    this.number_apps = obj && parseInt(obj.number_apps) || null;
  }

}

export class Appointement {
  id: string;
  start: Date;
  startTime: Date;
  end: Date;
  endTime: Date;
  doctor: string;
  docObj: Doctor;
  status: string;
  firstDay: boolean;
  insurance: number;
  reason: number;
  title: string;
  thirds_name: string;
  thirds_lastname: string;
  symptoms: string;
  reasonColor: string;
  patObj;
  patient:Patient;
  patExtObj;
  patientExt:Patient;
  attachments: string;
  bookedInternal: boolean;
  stornoTime;
  silentDep;
  deadline;
  reasonname;

  constructor(obj?: any) {

    this.id = obj && obj.id || null;
    if(obj && this.id==null && obj.uid) this.id=obj.uid
    this.start = obj && moment(obj.start).toDate() || null;
    this.startTime = this.start;
    this.end = obj && moment(obj.end).toDate() || null;
    this.endTime = this.end;
    this.doctor = obj && obj.doctor || null;
    this.docObj = obj && obj.docObj || new Doctor();
    this.status = obj && obj.status || null;
    this.insurance = obj && parseInt(obj.insurance) || null;
    this.firstDay = obj && obj.firstDay || false;
    this.bookedInternal = obj && obj.bookedInternal || false;
    this.reason = obj && obj.reason || null;
    this.reasonname = obj && obj.reasonname || null;
    this.reasonColor = obj && obj.color || null;
    this.title = obj && (obj.patientName && obj.patientName || "") + " " + (obj.patientSurname && obj.patientSurname || "") || "";
    this.thirds_name = obj && obj.thirds_name || null;
    this.thirds_lastname = obj && obj.thirds_lastname || null;
    this.symptoms = obj && obj.symptoms || null;
    this.patient = obj && obj.patient || null;
    this.patObj =  obj && {"id": obj.patientID, "address": obj.patientStreet, "anr": "", "city": obj.patientCity, "email": obj.patientMail, "land": "Deutschland", "mob": obj.patientMob, "tel": obj.patientTel, "zip": obj.patientZIP, "born": "", "insurance": obj.patientIns, "newsletter": false, "email_subscription": false, "name": obj.patientName, "surname": obj.patientSurname} || null;
    this.patient = obj && this.patObj || new Patient(this.patObj);
    this.patExtObj = obj && {"id": obj.patient_external, "address": obj.extPatientStreet, "anr": obj.extPatientTitle, "city": obj.extPatientCity, "email": obj.extPatientMail, "land": "Deutschland", "mob": "", "tel": obj.extPatientTel, "zip": obj.extPatientZIP, "born": "", "insurance": "", "newsletter": false, "email_subscription": false, "name": obj.extPatientName, "surname": obj.extPatientSurname} || null;
    this.patientExt = obj && this.patExtObj || new Patient(this.patExtObj);
    this.attachments = obj && obj.attachments || null;
    this.stornoTime = obj && obj.stornoTime || null;
    this.deadline = obj && obj.deadline || null;
  }


}

export class Patient {
  id: string;
  address: string;
  housenr: string;
  anr: string;
  born: string;
  city: string;
  email: string;
  insurance: string;
  land: string;
  mob: string;
  name: string;
  newsletter: boolean;
  email_subscription: boolean;
  surname: string;
  tel: string;
  zip: string;

  constructor(obj?: any) {
    this.id = obj && obj.id || null;
    this.address = obj && obj.address || null;
    this.housenr = obj && obj.housenr || null;
    this.anr = obj && obj.anr || null;
    this.born = obj && obj.born || null;
    this.city = obj && obj.city || null;
    this.email = obj && obj.email || null;
    this.insurance = obj && obj.insurance || null;
    this.land = obj && obj.land || null;
    this.mob = obj && obj.mob || null;
    this.name = obj && obj.name || null;
    if (obj && (obj.newsletter == "1" || obj.newsletter == true)) {
      this.newsletter = true;
    } else {
      this.newsletter = false;
    }
    if (obj && (obj.email_subscription == "1" || obj.email_subscription == true)) {
      this.email_subscription = true;
    } else {
      this.email_subscription = false;
    }
    this.surname = obj && obj.surname || null;
    this.tel = obj && obj.tel || null;
    this.zip = obj && obj.zip || null;
  }
}

export class Spec {
  id: string;
  name: string;

  constructor(obj?: any) {
    this.id = obj && obj.id || null;
    this.name = obj && obj.name || null;
  }
}

export class TopSpec {
  id: string;
  name: string;

  constructor(obj?: any) {
    this.id = obj && obj.fachid || null;
    this.name = obj && obj.fachgruppe || null;
  }
}
export class Zip {

  zipcodes: string[];
  zip: string;

  constructor(obj?: any) {

    this.zipcodes = obj&& obj.zipcodes;
  }
}


export class Med {
  PZN: number;
  Handelsname: string;
  Kombipraeparat: number;
  Darreichungsform: string;
  Darreichungsform_kurz: string;
  Wirkstaerke1: string;
  Wirkstaerke2: string;
  Wirkstaerke3: string;
  Wirkstoff1: string;
  Wirkstoff2: string;
  Wirkstoff3: string;

  constructor(obj?: any) {
    this.PZN = obj && obj.PZN || null;
    this.Handelsname = obj && obj.Handelsname || 'nicht verfügbar';
    this.Kombipraeparat = obj && obj.Kombipraeparat || 0;
    this.Darreichungsform = obj && obj.Darreichungsform || null;
    this.Darreichungsform_kurz = obj && obj.Darreichungsform_kurz || null;
    this.Wirkstaerke1 = obj && obj.Wirkstaerke1 || null;
    this.Wirkstoff1 = obj && obj.Wirkstoff1 || null;
    this.Wirkstaerke2 = obj && obj.Wirkstaerke2 || null;
    this.Wirkstoff2 = obj && obj.Wirkstoff2 || null;
    this.Wirkstaerke3 = obj && obj.Wirkstaerke3 || null;
    this.Wirkstoff3 = obj && obj.Wirkstoff3 || null;
  }
}

export class Message {
  id: string;
  title: string;
  message: string;
  sender: string;
  reciever: string;
  seen: boolean = null;
  created: Date;

  constructor(obj?: any) {
    this.id = obj && obj.id || null;
    this.created = obj && moment(obj.created).toDate() || null;
    this.sender = obj && obj.sender || null;
    this.title = obj && obj.title || null;
    this.message = obj && obj.message || null;
    this.reciever = obj && obj.reciever || null;
    if (obj && (obj.seen == "1" || obj.seen == true)) {
      this.seen = true;
    } else {
      this.seen = false;
    }
  }
}
export class Account {
  email: string;
  access: string;
  accessExp: string;
  refresh: string;
  name: string;

  constructor(obj?: any) {
    this.email = obj && obj.email || null;
    this.access = obj && obj.access || null;
    this.accessExp = obj && obj.accessExp || null;
    this.refresh = obj && obj.refresh || null;
    this.name = obj && obj.name || null;
  }
}

export class Employee {
  name: string;
  title: string;
  surname: string;
  image: string;
  department: string;



  constructor(obj?: any) {
    // Set default values
    this.name = "Name not available";
    this.title = "";
    this.surname = "Surname not available";
    this.image = "assets/images/no-doc.jpg"; // Default image
    this.department = "";


    // Debugging line

    // Directly set values if obj is provided
    if (obj) {
      this.name = obj.name || this.name;
      this.surname = obj.surname || this.surname;
      this.title = obj.designation || this.title; // Using designation as title
      this.department = obj.department || this.department; // Using department as practice

      // Handle image URL
      if (obj.image) {
        if (obj.image.indexOf("assets/images/no-doc.jpg") === -1) {
          if (obj.image.indexOf("https://termed.de/doctor/res/images/employees/") === -1) {
            this.image = "https://termed.de/doctor/res/images/employees/" + obj.image;
          } else {
            this.image = obj.image;
          }
        }
      }
    }

   // console.log('Processed employee:', this); // Debugging line
  }
}

export class newEmployee<T> {
  id?: string;
  position?: string;
  designation?: number;
  job?: string;
  profile?: string;
  tasks?: string;
  benefits?: string;
  description?: string;
  data?: T;

  constructor(obj?: Partial<newEmployee<T>>) {
    this.id = obj?.id || '';
    this.position = obj?.position || '';
    this.designation = obj?.designation || 0;
    this.job = obj?.job || '';
    this.profile = obj?.profile || '';
    this.tasks = obj?.tasks || '';
    this.benefits = obj?.benefits || '';
    this.description = obj?.description || '';
    this.data = obj?.data || {} as T;
  }
}

export interface PatientDashboardData {
  id: string;
  title: string;
  name: string;
  surname: string;
  address: {
    street: string;
    zip: string;
    city: string;
    lat: number;
    long: number;
  };
  praxis: string;
  hasAppointments: boolean;
  distance: string;
  docImage: string;
  hasRequests: boolean;
  hasMedRequests: boolean;
  isFavourite: boolean;
  hasPastAppointment: boolean;
  lastAppointmentDate: string;
  hasFutureAppointment: boolean;
  futureAppointmentDate: string;
  specID: number;
  specName: string;
  hasExternalAppointments: boolean;
  hasVSS: boolean;

  futureAppointments: AppointmentEntry[];
  pastAppointments: AppointmentEntry[];
}

export interface AppointmentEntry {
  id: number;
  start: string;
  end: string;
  doctor: string;
  status: number;
  reason: string;
  thirds: boolean;
  thirds_name: string;
  date: string
}







export class News {
  title: string;
  text: string;
  image: string;

  constructor(obj?: any) {
    // Set default values
    this.title = "";
    this.text = "text not available";
    this.image = "assets/images/newDesign/Logo.png"; // Default image

    // Debugging line

    // Directly set values if obj is provided
    if (obj) {
      this.text = obj.text || this.text;
      this.title = obj.title || this.title; // Using title as title
      if(obj.image != undefined){
        if (obj.image.indexOf("https://termed.de/doctor/res/images/news/") === -1) {
          this.image = "https://termed.de/doctor/res/images/news/" + obj.image;
        } else {
          this.image = obj.image;
        }
      }
    }
  }
}

export enum RequestTypes {
  General = 0,
  Appointment = 1,
  Medicine = 2,
  Transfer = 3
}

export interface SearchParams {
  search: string;
  specID: string;
  lat: number;
  long: number;
  limit: number;
  offset: number;
}

export interface SettingsField {
  type: string;
  header: string;
  value: any;
}

export const routeMap: { [key: string]: any } = {
  'Karriere': ['/karriere'],
  'aboutus': ['/about'],
  'Produkte': ['/products'],
  'produkt1': ['/reserve'],
  'produkt2': ['/access'],
  'produkt3': ['/connect'],
  'Kontakt': ['/contact'],
  'login': ['/login'],
  'products': ['/products'],
  'about': ['/about'],
  'karriere': ['/karriere']
};











